var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33132 18.0445L5.88299 16.5962C5.48459 16.1978 5.34397 15.6213 5.52208 15.087C5.6627 14.6698 5.85018 14.1261 6.07517 13.5027H1.11617C0.713076 13.5027 0.338105 13.2871 0.136558 12.9356C-0.0649895 12.584 -0.0603024 12.1528 0.145932 11.806L2.60668 7.65784C3.21601 6.63136 4.31749 6.00328 5.50802 6.00328H9.36554C9.47803 5.81579 9.59052 5.64237 9.70302 5.47363C13.5418 -0.188435 19.2601 -0.375921 22.6723 0.252156C23.216 0.350586 23.6379 0.777116 23.741 1.32082C24.3691 4.73775 24.1769 10.4514 18.5195 14.2901C18.3555 14.4026 18.1774 14.5151 17.9899 14.6276V18.4851C17.9899 19.6757 17.3618 20.7818 16.3353 21.3865L12.1872 23.8472C11.8404 24.0535 11.4091 24.0582 11.0576 23.8566C10.7061 23.6551 10.4905 23.2848 10.4905 22.877V17.8524C9.82957 18.082 9.25305 18.2695 8.81715 18.4101C8.29219 18.5789 7.72035 18.4336 7.32663 18.0445H7.33132ZM17.9899 7.87814C19.0257 7.87814 19.8647 7.03914 19.8647 6.00328C19.8647 4.96742 19.0257 4.12842 17.9899 4.12842C16.954 4.12842 16.115 4.96742 16.115 6.00328C16.115 7.03914 16.954 7.87814 17.9899 7.87814Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.fad3a3f7c15a0bba1da2bc451bf17934.svg";
export { ForwardRef as ReactComponent };